module.exports = __webpack_public_path__ + "static/media/logo-hkjc-all-project.2d3e2b5b.png";